<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-26 11:10:16
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-10 17:57:34
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/myPromonteGoods/tableCells/goodsActivity.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <rd-text width="130" class="activity-name font-h6-regular">{{ row.outerActivityName | formatEmpty }}</rd-text>
        <rd-text width="80" class="font-h6-regular text-default" :label="'活动ID'" :showCopy="true" :value="row.outerActivityId | formatEmpty"></rd-text>
        <div class="font-h6-regular text-default">推广有效期：{{ row.promotionEndTime | formatEmpty }}</div>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default{
    mixins: [mixin],
    data(){
        return{}
    }
}
</script>
<style lang="less" scoped>
.activity-name{
    color: @color-gy9;
}
.text-default{
    color: @color-gy7;
    /deep/ .copy-wrapper{
        opacity: 0;
    }
}
.rd-text:hover{
    /deep/ .copy-wrapper{
        opacity: 1;
    }
}
/deep/ .copy-wrapper:hover{
    .copy-hover{
        color: @color-primary !important;
    }
}
</style>